import { toFormData } from "axios";
import server_api from "data/server_apis/server_api";
const config = {
  headers: { "content-type": "multipart/form-data" },
};
// Machine
export const createMachine = (data) => {
  return server_api.post("/vending/machine", data);
};
export const getMachines = (page, location) => {
  return server_api.get(`/vending/machine?location=${location}&page=${page}`);
};
export const getAllMachines = () => {
  return server_api.get("/vending/machine/get_all");
};

export const getMachine = (id) => {
  return server_api.get(`/vending/machine/${id}`);
};
export const updateMachine = (id, data) => {
  return server_api.patch(`/vending/machine/${id}`, data);
};
export const deleteMachine = (id) => {
  return server_api.delete(`/vending/machine/${id}`);
};

export const activateMachine = (id) => {
  return server_api.get(`/vending/machine/${id}/activate`);
};

export const getMinMachines = () => {
  return server_api.get("/vending/machine/get_min_list");
};
export const changeMachinePassword = (id,data) => {
  return server_api.post(`/vending/machine/${id}/change_password`, data);
}

// Cabin
export const createCabin = (data) => {
  return server_api.post("/vending/cabin", data);
};
export const getCabins = () => {
  return server_api.get("/vending/cabin");
};
export const getAllCabins = () => {
  return server_api.get("/vending/cabin/get_all");
};

export const getCabin = (id) => {
  return server_api.get(`/vending/cabin/${id}`);
};
export const updateCabin = (id, data) => {
  return server_api.patch(`/vending/cabin/${id}`, data);
};
export const deleteCabin = (id) => {
  return server_api.delete(`/vending/cabin/${id}`);
};

export const activateCabin = (id) => {
  return server_api.get(`/vending/cabin/${id}/activate`);
};

export const createMultipleCabins = (data) => {
  return server_api.post("/vending/cabin/multy_cabins", data);
};

export const getCabinsByMachine = (id) => {
  return server_api.get(`/vending/cabin?machine=${id}`);
};

// Tray
export const createTray = (data) => {
  return server_api.post("/vending/tray", data);
};
export const getTrays = () => {
  return server_api.get("/vending/tray");
};
export const getAllTrays = () => {
  return server_api.get("/vending/tray/get_all");
};
export const getTray = (id) => {
  return server_api.get(`/vending/tray/${id}`);
};
export const updateTray = (id, data) => {
  return server_api.patch(`/vending/tray/${id}`, data);
};
export const deleteTray = (id) => {
  return server_api.delete(`/vending/tray/${id}`);
};
export const activateTray = (id) => {
  return server_api.get(`/vending/tray/${id}/activate`);
};

export const createMultipleTray = (data) => {
  return server_api.post("/vending/tray/multy_trays", data);
};

export const getTrayByCabin = (id) => {
  return server_api.get(`/vending/tray?cabin=${id}`);
};

// Partition
export const createPartition = (data) => {
  return server_api.post("/vending/partition", data);
};
export const getPartitions = () => {
  return server_api.get("/vending/partition");
};
export const getAllPartitions = () => {
  return server_api.get("/vending/partition/get_all");
};
export const getPartition = (id) => {
  return server_api.get(`/vending/partition/${id}`);
};
export const updatePartition = (id, data) => {
  return server_api.patch(`/vending/partition/${id}`, data);
};
export const deletePartition = (data) => {
  return server_api.delete(`/vending/partition/${data.id}`);
};
export const activatePartition = (id) => {
  return server_api.get(`/vending/partition/${id}/activate`);
};

export const createMultyPartition = (data) => {
  return server_api.post("/vending/partition/multy_partitions", data);
};
export const getPartitionsByTray = (id) => {
  return server_api.get(`/vending/partition?tray=${id}`);
};

export const getPartitionsArrangementByTray = (id) => {
  return server_api.get(`/vending/partition/with_arrangement?tray=${id}`);
};

// Display configurations
export const getDisplayConfigurations = (id) => {
  return server_api.get(`/vending/display-config/for_machine?id=${id}`);
};

export const updateDisplayConfigurations = (id, data) => {
  const formData = toFormData(data);

  return server_api.patch(`/vending/display-config/${id}`, formData, config);
};

// Machine photos
export const createMachinePhotos = (data) => {
  const formData = toFormData(data);

  return server_api.post(
    "/vending/machine-photos",
    formData,
    config
  );
};

export const deleteMachinePhotos = (id) => {
  return server_api.delete(
    `/vending/machine-photos/${id}`
  );
};

// Filling person assignments

export const assignFillingPerson = (data) => {
  return server_api.post("/vending/assign-filling-person-to-machine", data);
};
export const removeFillingPerson = (data) => {
  return server_api.post(
    "/vending/assign-filling-person-to-machine/remove_filling_persons",
    data
  );
};

// Machine assignments

export const assignMachineAdmin = (data) => {
  return server_api.post("/vending/assign-machine-admin-to-machine", data);
};
export const removeMachineAdmin = (data) => {
  return server_api.post(
    "/vending/assign-machine-admin-to-machine/remove_admin",
    {...data,machine_admin : data.machine_admin.id}
  );
};

export const assignAdmin = (data) => {
  
  return server_api.post("/vending/assign-admin-to-machine", data);
};
export const removeAdmin = (data) => {
  return server_api.post("/vending/assign-admin-to-machine/remove_admin", data);
};

// Machine assignments to location

export const assignMachineToLocation = (data) => {
  return server_api.post("/vending/assign-machine-to-location", data);
};

// Product Assignment
export const assignProduct = (data) => {
  return server_api.post("/commodity/product-assign", data);
};
export const productRemoval = (data) => {
  return server_api.post("/commodity/product-removal", data);
};
